import { ReactTFC } from "../../../../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { fontColor, FONTS, fontSize } from "../../../../../../styles/fonts";
import { CSS_COLORS, CSS_SPACER_SIZES } from "../../../../../../styles/styles-css-variables";
import { SwarovskiButton } from "../../../../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";

export const TextWithHeadlineAndButtonElements: ReactTFC<{
  headline: React.ReactNode;
  paragraph: React.ReactNode;
  buttonLabel: React.ReactNode;
  buttonAction: () => void;
}> = props => {
  return (
    <>
      <span
        css={css`
          ${FONTS.MinervaModern500}
          font-size: 30px;
          color: ${CSS_COLORS.Green};
          letter-spacing: 1.5px;
          text-align: center;
          line-height: 30px;

          text-transform: uppercase;

          margin-top: 25px;
          margin-bottom: 25px;
        `}
      >
        {props.headline}
      </span>
      <p
        css={[
          FONTS.SwarovskiFutura300,
          fontColor.black,
          fontSize.x2,
          css`
            text-align: center;

            margin-top: 0;
            margin-bottom: ${CSS_SPACER_SIZES.md};
          `,
        ]}
      >
        {props.paragraph}
      </p>

      <div
        css={css`
          margin-bottom: 14px;
          display: flex;
          justify-content: center;
        `}
      >
        <SwarovskiButton variant={"green"} as={"button"} onClick={props.buttonAction}>
          {props.buttonLabel}
        </SwarovskiButton>
      </div>
    </>
  );
};
